import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { SidebarTrigger } from "@/components/ui/sidebar"
import { usePage } from '@inertiajs/react'

export function SiteHeader() {
  const { props: pageProps } = usePage<{ auth: { isAuthenticated: boolean } }>()
  const isAuthenticated = pageProps.auth?.isAuthenticated ?? false
  
  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-b transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mx-2 data-[orientation=vertical]:h-4"
        />
        <div className="ml-auto flex items-center gap-2 p-2">
          {!isAuthenticated && (
            <>
              <Button variant="ghost" asChild size="sm">
                <a href="/users/sign_in">
                  Sign In
                </a>
              </Button>
              <Button variant="default" asChild size="sm">
                <a href="/users/sign_up">
                  Sign Up
                </a>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
